// Major
import React from "react";
import { Grid } from "@mui/material";

// Components
import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import MKTypography from "components/MKTypography";
import HeaderContainer from "styles/components/headerContainer";
import { ImageContainer } from "styles/components/imageContainer";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import MKButton from "components/MKButton";

// Styles
import theme from "assets/theme";
import { Link } from "react-router-dom";
import { StyledButtonContainer } from "index.styles";
import { StyledSectionContainerColorWrapper } from "styles/components/SectionContainer/index.styles";

import useMediaQueries from "utils/mediaQueries.utils";
// ! Uncomment to add animations (removed animations for now)
// import withSectionAnimation from "styles/animations/components/withSectionAnimation";
// import { fadeInVariants } from "styles/animations/sectionFadeIn.animations";

// const AnimatedStyledSectionContainer = withSectionAnimation(StyledSectionContainer, fadeInVariants);

const GetStartedToday = ({ ...props }) => {
  const { leftColumn, rightColumn, colorWrapper, flipBackground, hideSubtext = false } = props;
  const { isLg } = useMediaQueries();
  const rightContent = () => {
    const { title, highlightText, description, cta } = rightColumn;
    const textColor = colorWrapper ? theme.palette.common.white : theme.palette.primary.main;

    return (
      <Grid item xs={12} md={6}>
        <HeaderContainer
          title={title}
          variant="h2"
          component="h2"
          textColor={textColor}
          highlightText={highlightText}
          highlightColor={theme.palette.accent.main}
        />
        <MKTypography variant={isLg ? "body1" : "body2"} fontWeight={400} gutterBottom sx={{ color: textColor }}>
          {Array.isArray(description)
            ? description.map((seg, i) =>
                seg.link ? (
                  <Link
                    key={i}
                    to={seg.link}
                    target={seg.external ? "_blank" : undefined}
                    rel={seg.external ? "noopener noreferrer" : undefined}
                    style={{ color: theme.palette.accent.main, fontWeight: 700, textDecoration: "none" }}
                  >
                    {seg.text}
                  </Link>
                ) : (
                  <React.Fragment key={i}>{seg.text}</React.Fragment>
                )
              )
            : description}
        </MKTypography>
        <StyledButtonContainer>
          <MKButton
            variant="contained"
            color="secondary"
            size="large"
            component={Link}
            to={cta.link}
            aria-label={cta.ariaLabel && cta.ariaLabel}
            target={cta.external ? "_blank" : undefined}
            rel={cta.external ? "noopener noreferrer" : undefined}
          >
            {cta.text}
          </MKButton>
        </StyledButtonContainer>
        {!hideSubtext && (
          <MKTypography variant="body2" fontWeight={400} gutterBottom sx={{ padding: "1rem 0rem !important", color: theme.palette.accent.main }}>
            (Just takes 2 minutes)
          </MKTypography>
        )}
      </Grid>
    );
  };

  const leftContent = () => {
    const { image } = leftColumn;
    return (
      <Grid item xs={12} md={5}>
        <ImageContainer image={image.imageUrl} alt={image.alt} cssProps={{ maxHeight: isLg ? "500px" : "300px", objectFit: "contain" }} />
      </Grid>
    );
  };

  return (
    <>
      {colorWrapper ? (
        <StyledSectionContainerColorWrapper flipBackground={flipBackground}>
          <StyledSectionContainer id="ketamine-hub-get-started">
            <TwoColumnSection
              cssProps={{ justifyContent: "space-between !important" }}
              columnGap={6}
              rowGap={2}
              leftComponent={leftContent()}
              rightComponent={rightContent()}
            />
          </StyledSectionContainer>
        </StyledSectionContainerColorWrapper>
      ) : (
        <StyledSectionContainer id="ketamine-hub-get-started">
          <TwoColumnSection
            cssProps={{ justifyContent: "space-between !important" }}
            columnGap={6}
            rowGap={2}
            leftComponent={leftContent()}
            rightComponent={rightContent()}
          />
        </StyledSectionContainer>
      )}
    </>
  );
};

export default GetStartedToday;
